const routes = {
    path: 'aplicacoes',
    name: 'Aplicacoes',
    component: () => import('./Listagem.vue'),
    meta: {
        rules: ['CTRLACS-APP-00'],
    },
    children: [
        {
            path: ':id/detalhar',
            name: 'Aplicacoes_Detalhar',
            component: () => import('./AplicacaoForm.vue'),
            meta: {
                rules: ['CTRLACS-APP-02'],
            },
        },
        {
            path: 'inserir',
            name: 'Aplicacoes_Inserir',
            component: () => import('./AplicacaoForm.vue'),
            meta: {
                rules: ['CTRLACS-APP-01'],
            },
        },
        {
            path: ':id/atualizar',
            name: 'Aplicacoes_Atualizar',
            component: () => import('./AplicacaoForm.vue'),
            meta: {
                rules: ['CTRLACS-APP-03'],
            },
        },
    ],
};

export default routes;
